import device from "current-device";

export function isAndroid() {
  return device.android();
}

export function isiOS() {
  return device.ios();
}
